import { RootState } from '../store';

export const selectLoading = (state: RootState) => state.retailers.isLoading;
export const retailerData = (state: RootState) => state.retailers;
export const selectedRetailer = (state: RootState) =>
  state.retailers.selectedRetailer;
export const companyDetails = (state: RootState) =>
  state.retailers.companyDetails;
export const ledgerRows = (state: RootState) => state.retailers.ledgerRows;
export const ledgerCount = (state: RootState) => state.retailers.ledgerCount;
export const isLedgerLoading = (state: RootState) =>
  state.retailers.isLedgerLoading;
